import { useContext } from "react";
import LoginContext from "../../store/loginContext";

import { Navigate, Outlet, useLocation } from "react-router-dom";

export const AuthLayout = () => {
  const location = useLocation();
  const LoginCtx = useContext(LoginContext);

  return LoginCtx?.isLogin ? (
    <Outlet />
  ) : (
    <Navigate to="/login" replace state={{ from: location }} />
  );
};
